import { render, staticRenderFns } from "./PricingVariant.vue?vue&type=template&id=15b52e68"
import script from "./PricingVariant.vue?vue&type=script&lang=js"
export * from "./PricingVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports